"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStore;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createStore(initialState) {
  var state = initialState;
  var listeners = [];
  function setState(partial) {
    state = _objectSpread(_objectSpread({}, state), partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }
  function getState() {
    return state;
  }
  function resetSelectedKeys() {
    state = _objectSpread(_objectSpread({}, state), {}, {
      selectedRowKeys: [],
      halfSelectedRowKeys: []
    });
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }
  function subscribe(listener) {
    listeners.push(listener);
    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }
  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe,
    resetSelectedKeys: resetSelectedKeys
  };
}